module.exports = "https://static.zego.com/_next/static/images/blog-category-b2b-d55ca4aa3f4c5729c045fe669436258f.jpg";